import React from "react";

const LOGOS = [
  { name: "The Energy", src: "/brand/clients/the-energy.png", h: "h-6 md:h-7" },
  { name: "The a2 Milk Company", src: "/brand/clients/a2-milk.png", h: "h-12 md:h-14" },
  { name: "PSG", src: "/brand/clients/psg.png", h: "h-6 md:h-7" },
  { name: "Chris O'Brien Lifehouse", src: "/brand/clients/coblh.png", h: "h-10 md:h-12" },
  { name: "Forbes", src: "/brand/clients/forbes.webp", h: "h-7 md:h-8" },
];

export default function Ticker() {
  return (
    <section
      data-testid="logo-strip-section"
      aria-label="Trusted by"
      className="bg-white py-16 md:py-20 border-y border-black/10"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-14">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4 mb-10 md:mb-14">
          <div>
            <p className="overline mb-3">Trusted by</p>
            <h3 className="font-display font-bold text-2xl md:text-3xl tracking-tight max-w-xl text-[#0A0A0A]">
              Teams across media, health, policy, and industry.
            </h3>
          </div>
        </div>

        <div className="flex flex-wrap items-center justify-center md:justify-between gap-x-10 md:gap-x-14 gap-y-10">
          {LOGOS.map((logo, i) => (
            <img
              key={logo.name}
              src={logo.src}
              alt={logo.name}
              data-testid={`logo-${i}`}
              draggable="false"
              loading="lazy"
              className={`${logo.h} w-auto select-none object-contain grayscale opacity-60 hover:grayscale-0 hover:opacity-100 transition-[filter,opacity] duration-300`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
